module.exports = __webpack_public_path__ + "log-in/img/404.dced3671.jpg";